export default __webpack_public_path__ + "static/media/image_full_50.6c7bb8d2.svg";